<div class="pdf-page-container">

  <!-- Page content -->
  <div class="pdf-page-content with-sidebar">

    <div class="visible-xs-block text-center mobile-sidebar-toggle">
      <a [attr.href] = "null" (click)="showSidebar()"><i class="{{toogleSidebar ? 'icon-minus3' : 'icon-plus3'}}"></i> {{'Sidebar Menu' | translate}}</a>
    </div>

    <!-- Main sidebar -->
    <div class="sidebar sidebar-main sidebar-default sidebar-separate">
      <div class="sidebar-content">

        <!-- Designer Toolbar will be moved here -->
        <div class="category-content no-padding">
          <div #toolbarContainer class="designer-toolbar-container" id="external-toolbar"></div>
        </div>

      </div>
    </div>
    <!-- /main sidebar -->

    <!-- Main content -->
    <div class="pdf-content-area">

      <!-- Content area -->
      <div class="content" *ngIf="!pdfLoading && pdfSrc.url">

        <!-- PDF Form Designer Component -->
        <lib-pdf-form-designer
          #pdfDesigner
          [pdfSrc]="pdfSrc"
          [initialConfiguration]="initialConfiguration"
          [initialZoom]="currentZoom"
          [externalToolbar]="externalToolbar"
          [toolbarContainerId]="'external-toolbar'"
          [options]="designerOptions"
          (configurationChange)="onConfigurationChange($event)"
          (zoomChange)="onZoomChange($event)">
        </lib-pdf-form-designer>

      </div>
      <!-- /content area -->

    </div>
    <!-- /main content -->

  </div>
  <!-- /page content -->

</div>
